import { Box, Drawer, Typography, useTheme, IconButton } from '@mui/material';
import { FiBox, FiDatabase } from 'react-icons/fi';
import { useNavigate, useParams } from 'react-router-dom';
import { useState } from 'react';
import DataSet from 'pages/Business/Setting/DataSet';
import RetrievalTesting from 'pages/Business/Setting/RetrievalTesting';
import { IoClose } from 'react-icons/io5';

export default function KnowledgeForm() {
  const theme = useTheme();
  const navigate = useNavigate();
  const { knowledgeBaseId } = useParams();

  const [knowledgeBase, setKnowledgeBaseTab] = useState('dataset');

  return (
    <Drawer
      anchor='right'
      open={true}
      onClose={() => navigate(-1)}
      sx={{
        '& .MuiDrawer-paper': {
          width: { xs: '100%', sm: 600, md: 800, lg: 1134 },
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          zIndex: 100001
        }
      }}
    >
      {/* Fixed Header */}
      <Box
        sx={{
          px: { xs: 2, lg: 3 },
          py: { xs: 1.5, lg: 2 },
          borderBottom: '1px solid #DEDEDE',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          flexShrink: 0
        }}
      >
        <Typography variant='h6' sx={{ fontSize: { xs: '1.125rem', lg: '1.25rem' } }}>
          {knowledgeBaseId ? 'Edit' : 'Create'} Knowledge Base
        </Typography>
        <IconButton
          onClick={() => navigate(-1)}
          size='small'
          sx={{
            p: { xs: 0.75, lg: 1 }
          }}
        >
          <IoClose size={20} />
        </IconButton>
      </Box>

      {/* Scrollable Content */}
      <Box
        sx={{
          flex: 1,
          overflow: 'auto',
          p: { xs: 2, lg: 3 },
          bgcolor: '#F8F9FA'
        }}
      >
        <Box
          display='flex'
          alignItems='center'
          gap={2}
          bgcolor='#fff'
          borderRadius={1}
          sx={{
            width: { xs: '100%', md: 'fit-content' }
          }}
          mb={3}
        >
          <Box
            display='flex'
            alignItems='center'
            gap={1}
            color={knowledgeBase === 'dataset' ? theme.palette.primary.main : ''}
            padding={{ xs: '8px 16px', lg: '8px 24px' }}
            sx={{
              borderRadius: '8px',
              bgcolor: knowledgeBase === 'dataset' ? theme.palette.primary.light : '',
              cursor: 'pointer',
              flex: { xs: 1, md: 'unset' }
            }}
            onClick={() => setKnowledgeBaseTab('dataset')}
          >
            <FiDatabase />
            <Typography sx={{ fontSize: { xs: '0.875rem', lg: '1rem' } }}>Dataset</Typography>
          </Box>

          <Box
            display='flex'
            alignItems='center'
            gap={1}
            color={knowledgeBase === 'retrieval' ? theme.palette.primary.main : ''}
            padding={{ xs: '8px 16px', lg: '8px 24px' }}
            sx={{
              borderRadius: '8px',
              bgcolor: knowledgeBase === 'retrieval' ? theme.palette.primary.light : '',
              cursor: 'pointer',
              flex: { xs: 1, md: 'unset' }
            }}
            onClick={() => setKnowledgeBaseTab('retrieval')}
          >
            <FiBox />
            <Typography sx={{ fontSize: { xs: '0.875rem', lg: '1rem' } }}>Retrieval Testing</Typography>
          </Box>
        </Box>
        {knowledgeBase === 'dataset' && <DataSet />}
        {knowledgeBase === 'retrieval' && <RetrievalTesting isRenderInModal={true} />}
      </Box>
    </Drawer>
  );
}
